import {Injectable} from '@angular/core';
import {HttpHeaders, HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {JwtService} from './jwt.service';
import {ErrorObservable} from 'rxjs/observable/ErrorObservable';
import {catchError} from 'rxjs/operators/catchError';
import {ApiConfig} from '../utils/config';

export interface ApiResponse {
    success: boolean;
    result: any;
}

@Injectable()
export class ApiService {
    constructor(
        private http: HttpClient,
        private jwtService: JwtService,
        private apiConfig: ApiConfig
    ) { }

    private formatErrors(error: any) {
        return new ErrorObservable(error.error);
    }

    get(path: string, params: HttpParams = new HttpParams()): Observable<ApiResponse> {
        return this.http.get(`${this.apiConfig.API_URL}${path}`, {params})
            .pipe(catchError(this.formatErrors));
    }

    put(path: string, body: Object = {}): Observable<ApiResponse> {
        return this.http.put(
            `${this.apiConfig.API_URL}${path}`,
            JSON.stringify(body)
        ).pipe(catchError(this.formatErrors));
    }

    post(path: string, body: Object = {}, headers = {}): Observable<ApiResponse> {
        return this.http.post(
            `${this.apiConfig.API_URL}${path}`,
            JSON.stringify(body),
            {
                headers: {
                    ...headers,
                    'Content-Type': 'application/json'
                }
            }
        ).pipe(catchError(this.formatErrors));
    }

    uploadFile(body, pathToFolder, filename, apiPath) {
        return Observable.create(observer => {
            const xhr = new XMLHttpRequest();
            const token = this.jwtService.getToken();

            xhr.onreadystatechange = () => {

                if (xhr.readyState === XMLHttpRequest.OPENED) {
                    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
                    xhr.setRequestHeader('pathToFolder', pathToFolder);
                    xhr.setRequestHeader('filename', filename);
                    xhr.send(body);
                }
                if (xhr.readyState !== XMLHttpRequest.DONE) {
                    // console.log(xhr);
                    return {};
                }
                if (xhr.status === 200) {
                    const json = JSON.parse(xhr.responseText);
                    if (json.success) {
                        observer.next(json);
                        observer.complete();
                    }
                } else {
                    console.warn('error');
                    observer.error(xhr.response);
                }
            };
            xhr.open('POST', `${this.apiConfig.API_URL}${apiPath}`);
        });
    }

    delete(path: string, params?: any, options?: {}): Observable<ApiResponse> {
        return this.http.delete(
            `${this.apiConfig.API_URL}${path}`,
            params
        ).pipe(catchError(this.formatErrors));
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/api.service.ts